import { LocationStatusAttributesType, LocationStatusType } from "@/types/locations/stutus";
import {
  LocationStatusAttributesInterface,
  LocationStatusInterface,
  LocationsStatusesInterface,
} from "@/interface/locations/status";

/**
 * Location Status Attributes
 * class
 */
export class LocationStatusAttributes implements LocationStatusAttributesInterface {
  BusinessID: string = "";
  BusinessName: string = "";
  StatsUpdateBy: string = "";
  StatusChangedAt: string = "";
  createdAt: string = "";
  currentStatus: string = "";
  currentStatusText: string = "";
  locationID: string = "";
  locationName: string = "";
  registerName: string = "";
  updatedAt: string = "";
  constructor(data?: LocationStatusAttributesType) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

/**
 * Location Status
 * class
 */
export class LocationStatus implements LocationStatusInterface {
  id: string = "";
  className: string = "";
  _objCount: number = 0;
  locationId: string = "";
  attributes: LocationStatusAttributesInterface = new LocationStatusAttributes();
  constructor(data: LocationStatusType) {
    if (data) {
      Object.assign(this, data);
      this.attributes = new LocationStatusAttributes(data?.attributes);
      this.locationId = this.attributes?.locationID;
    }
  }
}

/**
 * Locations statuses list
 * class
 */
export class LocationsStatuses implements LocationsStatusesInterface {
  list: Array<LocationStatusInterface> = [];

  constructor(data: Array<LocationStatusType>) {
    this.list = data.flatMap((item) => new LocationStatus(item));
    // console.log("LocationsStatuses list", this.list, this);
  }

  /**
   * Update specific location status
   * @param LocationStatus
   * @return {void}
   */
  updateLocationStatus(LocationStatus: LocationStatusInterface): void {
    const itemIndex = this.list.findIndex((item) => item.locationId === LocationStatus.locationId);
    // console.log("***** before update location status is ", this.list[itemIndex]);
    this.list[itemIndex] = { ...LocationStatus };
    // console.log("Business name: ", LocationStatus?.attributes?.BusinessName);
    // console.log("*****update location status is ", itemIndex, this.list[itemIndex], LocationStatus);
    // debugger;
  }
}
